var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 100,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 64 64",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_7486747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exp-2.-F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52 35.617h-40v18.512c0 .883.579 1.662 1.425 1.916 4.019 1.205 15.321 4.596 18 5.4.375.112.775.112 1.15 0 2.679-.804 13.981-4.195 18-5.4.846-.254 1.425-1.033 1.425-1.916 0-4.636 0-18.512 0-18.512z",
    fill: "#cadcf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 35.617h-20s-.194 25.912 0 25.912.387-.028.575-.084c2.679-.804 13.981-4.195 18-5.4.846-.254 1.425-1.033 1.425-1.916 0-4.636 0-18.512 0-18.512z",
    fill: "#a4bbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 42.106-20-6.489s-3.507 5.2-5.075 7.524c-.176.261-.219.588-.117.885.103.297.338.528.637.626 3.799 1.234 15.045 4.888 17.995 5.846.423.138.887-.021 1.137-.39 1.341-1.979 5.423-8.002 5.423-8.002z",
    fill: "#e9f3fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 35.617-20 6.489s4.082 6.023 5.423 8.002c.25.369.714.528 1.137.39 2.95-.958 14.196-4.612 17.995-5.846.299-.098.534-.329.637-.626.102-.297.059-.624-.117-.885-1.568-2.324-5.075-7.524-5.075-7.524z",
    fill: "#e9f3fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.159 21.986c-.25-.367-.713-.526-1.136-.388-2.948.957-14.197 4.612-17.996 5.847-.299.097-.535.328-.637.625s-.059.625.117.885c1.444 2.142 4.493 6.662 4.493 6.662l20-6.511s-3.592-5.283-4.841-7.12z",
    fill: "#cadcf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.493 28.955c.176-.26.219-.588.117-.885s-.338-.528-.637-.625c-3.799-1.235-15.048-4.89-17.996-5.847-.423-.138-.886.021-1.136.388-1.249 1.837-4.841 7.12-4.841 7.12l20 6.511s3.049-4.52 4.493-6.662z",
    fill: "#e9f3fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 35.617-20-6.511-20 6.511 20 6.489z",
    fill: "#cadcf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 42.106v-13l-20 6.511z",
    fill: "#a4bbdb"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#347bfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.982 31.978c-.416-.272-.791-.563-1.124-.868-.406-.373-1.039-.346-1.413.061-.373.406-.346 1.039.061 1.412.409.376.87.734 1.382 1.069.462.302 1.082.172 1.384-.29s.172-1.082-.29-1.384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.866 28.906c-.297-.403-.548-.808-.754-1.213-.25-.492-.853-.688-1.345-.438s-.688.853-.438 1.345c.254.498.562.997.927 1.492.327.444.953.539 1.398.212.444-.328.539-.954.212-1.398z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.404 24.825c.01-.403.069-.794.177-1.169.152-.53-.155-1.085-.686-1.237-.53-.152-1.085.155-1.237.686-.153.536-.239 1.095-.254 1.67-.013.552.423 1.011.975 1.024.552.014 1.011-.422 1.025-.974z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.942 21.485c.257-.238.545-.458.86-.657.467-.295.607-.913.313-1.379-.295-.467-.913-.607-1.38-.313-.423.267-.807.562-1.152.882-.405.375-.429 1.008-.054 1.413s1.008.429 1.413.054z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.661 19.76c.503-.093 1.036-.153 1.598-.176.552-.024.98-.491.957-1.042s-.49-.98-1.042-.957c-.66.028-1.286.099-1.877.208-.542.101-.902.623-.801 1.165.1.543.622.902 1.165.802z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.873 19.701c.853.01 1.647-.02 2.384-.085.55-.049.957-.535.908-1.085-.049-.549-.535-.956-1.085-.907-.675.059-1.402.087-2.184.077-.552-.006-1.005.437-1.011.988-.007.552.436 1.006.988 1.012z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.544 19.003c.99-.303 1.826-.691 2.526-1.136.465-.297.603-.915.306-1.381-.296-.465-.915-.603-1.381-.306-.563.358-1.238.666-2.036.91-.527.162-.825.721-.663 1.249.161.528.721.825 1.248.664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.634 15.068c.472-.976.653-2.008.607-3.003-.026-.552-.495-.978-1.046-.952s-.978.494-.952 1.045c.032.676-.09 1.377-.41 2.04-.24.497-.032 1.096.465 1.336s1.096.031 1.336-.466z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.997 8.529c-.729-.985-1.718-1.671-2.796-1.892-.541-.11-1.07.238-1.181.779-.11.541.239 1.07.779 1.181.622.127 1.17.554 1.591 1.123.329.443.956.536 1.399.208.444-.329.537-.956.208-1.399z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m30.933 6.831c1.082-6.127 10.459-5.731 5 0z",
    fill: "#cadcf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.933 8.383c1.082 6.126 10.459 5.731 5 0z",
    fill: "#cadcf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.843 8.617h6.696c.552 0 1-.448 1-1s-.448-1-1-1h-6.696c-.551 0-1 .448-1 1s.449 1 1 1z",
    fill: "#347bfa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataList);
export default __webpack_public_path__ + "static/media/no-data-list.3ca98570b627b6b290d2737a3d5bad9f.svg";
export { ForwardRef as ReactComponent };